var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.1015L13 15.1015V9.95954C14.721 9.51254 16 7.95955 16 6.10155C16 3.89556 14.206 2.10156 12 2.10156C9.794 2.10156 8 3.89556 8 6.10155C8 7.95955 9.279 9.51254 11 9.95954V15.1015L12 17.1015Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.267 10.6651L15.734 12.5931C18.325 13.3091 20 14.6861 20 16.102C20 17.994 16.715 20.102 12 20.102C7.285 20.102 4 17.994 4 16.102C4 14.6861 5.675 13.3091 8.267 12.5921L7.734 10.6641C4.197 11.6421 2 13.7251 2 16.102C2 19.466 6.393 22.102 12 22.102C17.607 22.102 22 19.466 22 16.102C22 13.7251 19.803 11.6421 16.267 10.6651Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinIcon);
export default __webpack_public_path__ + "static/media/mapPinIcon.00711eb58776b17075b5b6d5bbfd3ea3.svg";
export { ForwardRef as ReactComponent };